<template>
  <div class="text-sm bg-white">
    <!-- copy this route.params {{$route.params}} -->

    <div class="flex justify-center">
      <div class="text-sm">
        <div class="my-4 text-center text-2xl">
          NOTE:

          <!-- <pre>
            {{data}}
          </pre> -->
        </div>
        <div>
          <NoteContent />
        </div>

        <div class="text-center py-10">
          <v-btn dark color="#505050" @click="finishBook">I understand</v-btn>
        </div>

        <div class="p-10 bg-white" v-if="showDialog">
          <Dialog @endButton="endButton" :showDialog="showDialog" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SecureStorage from "../../../utils/secureStorage";
import Dialog from "../components/Dialog.vue";
import NoteContent from "../components/NoteContent.vue";
import axios from "axios";

export default {
  data() {
    return {
      showDialog: false,
      booked_dialog: false,
    };
  },
  components: { NoteContent, Dialog },
  props: ["dialog_note", "data"],
  methods: {
    endButton(e) {
      this.$router.push({ name: e });
    },
    onPressBack() {
      this.$router.push({ name: "AppointmentSummary" });
    },
    backHomePage() {
      this.$router.push("/home/dashboard");
    },
    finishBook() {
      this.booked_dialog = true;
      this.showDialog = true;
      this.axiosSubmit();
    },
    axiosSubmit() {
      let data = {
        user_id: SecureStorage.getItem("auth").userId,
        classification_id: 6, //book appointment in table classification
        status_id: 1, //new
        remarks_id: 1,
        subject: this.data.purposes,
        // subject: `Appointment on ${this.data.appointment_date} at ${this.data.selected_time}`,
        appointment_type_id: 1,
        appointment_date: this.data.appointment_date,
        appointment_time:
          this.data.selected_time.time_table +
          " - " +
          this.data.selected_time.am_pm,
        appointment_purposes: this.data.purposes,
        bk_apt_note_id: 1,
        apt_purpose_id: 1,
        time_table_id: this.data.selected_time.time_table_id,
        contract_number: SecureStorage.getItem("auth").contract_number,
        property: SecureStorage.getItem("auth").property,
        customer_code: SecureStorage.getItem("auth").customerCode,
        buyer_name: SecureStorage.getItem("auth").buyerName,
        email: SecureStorage.getItem("auth").email,
      };

      // Validation to ensure data is not null or empty
      for (let key in data) {
        if (!data[key]) {
          console.log(
            "System is currently unavailable for request. Please try again."
          );
          return;
        }
      }

      axios
        .post("/tickets/add", data)
        .then((res) => {
          console.log("res", res.data);
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
};
</script>

<style scoped>
td {
  border: solid #ccc;
  padding: 2px;
}
table {
  border: solid #505050;
}
</style>
